import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview, GA_TRACKING_ID, GOOGLE_ADS_ID } from '@/utils/gtag';

export const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // GA4 page view
      pageview(location.pathname + location.search);
      // Ensure Google Ads base tag is configured on SPA route changes too
      if (window.gtag && GOOGLE_ADS_ID) {
        window.gtag('config', GOOGLE_ADS_ID, { page_path: location.pathname + location.search });
      }
    }
  }, [location]);

  return null; // Google Analytics is loaded directly in index.html
};